import React from 'react'
import {
  formatReportTitleFragment,
  ReportTitleFormatState,
} from '@utils/textCase.util'

type ReportSectionHeadingProps = React.PropsWithChildren<{
  className?: string
}>

function sentenceCaseTitleNode(
  node: React.ReactNode,
  state: ReportTitleFormatState,
): React.ReactNode {
  if (typeof node === 'string') return formatReportTitleFragment(node, state)
  if (Array.isArray(node)) {
    return node.map((child) => sentenceCaseTitleNode(child, state))
  }
  return node
}

function ReportSectionHeading({
  className,
  children,
}: ReportSectionHeadingProps): React.ReactElement {
  return (
    <h3 className={className}>
      {sentenceCaseTitleNode(children, { titled: false, insideParen: false })}
    </h3>
  )
}

export default ReportSectionHeading
